import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function CloseEmailIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
    >
      <g id="Cancelled" transform="translate(-332 -415)">
        <circle
          id="Ellipse_131"
          data-name="Ellipse 131"
          cx="10"
          cy="10"
          r="10"
          transform="translate(332 415)"
          fill={color || "#2f2f2f"}
        />
        <path
          id="Path_10030"
          data-name="Path 10030"
          d="M-6.859-8.937l2.274-2.274a.715.715,0,0,0,0-1.011l-.505-.505a.715.715,0,0,0-1.011,0l-2.274,2.274-2.274-2.274a.715.715,0,0,0-1.011,0l-.505.505a.715.715,0,0,0,0,1.011l2.274,2.274-2.274,2.274a.715.715,0,0,0,0,1.011l.505.505a.715.715,0,0,0,1.011,0l2.274-2.274L-6.1-5.147a.715.715,0,0,0,1.011,0l.505-.505a.715.715,0,0,0,0-1.011Z"
          transform="translate(350.375 433.938)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}
